export interface CollectionItem {
  id: string;
  slug: string;
  title: string;
  category: string;
  categoryKey: string;
  series: string;
  author: string;
  excerpt: string;
  tag: string;
  count: string;
  updated: string;
  cover: string;
}

export const collections: CollectionItem[] = [
  {
    id: "c1",
    slug: "xiaochuanyu-fangtan-quanji",
    title: "小川望春·访谈全记录合集",
    category: "动画合集",
    categoryKey: "anime",
    series: "小川望春导演系列",
    author: "档案组 · 夏目",
    excerpt:
      "收录小川望春导演历年剧场版与 TV 系列的访谈、分镜与特典索引，按时间线整理，方便按作品逐部收藏与核对补全。",
    tag: "导演专题",
    count: "12 部",
    updated: "2026-08-12",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20artbook%20cover%20illustration%20portrait%2C%20cinematic%20film%20director%20collection%20theme%2C%20warm%20amber%20and%20rust%20tone%20watercolor%2C%20soft%20studio%20lighting%2C%20minimalist%20editorial%20cover%20layout%20with%20negative%20space&width=720&height=960&seq=col-anime-01&orientation=portrait",
  },
  {
    id: "c2",
    slug: "senjing-zhizi-manhua",
    title: "森井直子·少女漫画卷宗",
    category: "漫画合集",
    categoryKey: "manga",
    series: "森井直子作品集",
    author: "档案组 · 杏子",
    excerpt:
      "森井直子出道至今的少女漫画单行本、短篇与再版索引，含卷数与出版年份对照表，补齐目录后可按作者批量收藏。",
    tag: "作者专题",
    count: "28 卷",
    updated: "2026-08-09",
    cover:
      "https://readdy.ai/api/search-image?query=manga%20volume%20stack%20portrait%20cover%2C%20shojo%20manga%20collection%20theme%2C%20warm%20cream%20background%20with%20soft%20peach%20and%20olive%20accents%2C%20gentle%20studio%20lighting%2C%20clean%20editorial%20composition&width=720&height=960&seq=col-manga-02&orientation=portrait",
  },
  {
    id: "c3",
    slug: "xinghai-linye-youxi",
    title: "星海林野·冒险游戏系列",
    category: "游戏合集",
    categoryKey: "game",
    series: "星海林野系列",
    author: "档案组 · 阿茶",
    excerpt:
      "星海林野系列主机与 PC 版的历代版本、DLC 与资料片整理，含平台对应关系，收藏玩家可按系列一站式补齐。",
    tag: "系列专题",
    count: "9 款",
    updated: "2026-08-05",
    cover:
      "https://readdy.ai/api/search-image?query=adventure%20game%20collection%20portrait%20cover%2C%20star%20field%20and%20forest%20theme%2C%20warm%20teal%20and%20amber%20tone%20digital%20painting%2C%20soft%20glow%20lighting%2C%20minimalist%20box%20art%20composition&width=720&height=960&seq=col-game-03&orientation=portrait",
  },
  {
    id: "c4",
    slug: "moonlight-wenku",
    title: "月光文库·轻小说补全索引",
    category: "轻小说合集",
    categoryKey: "novel",
    series: "月光文库系列",
    author: "档案组 · 小鹿",
    excerpt:
      "月光文库旗下多部轻小说的卷次对照、连载进度与设定集整理，整理贴持续补全，方便读者按系列追更与收藏。",
    tag: "文库专题",
    count: "34 卷",
    updated: "2026-07-30",
    cover:
      "https://readdy.ai/api/search-image?query=light%20novel%20books%20portrait%20cover%2C%20moonlit%20library%20theme%2C%20warm%20night%20blue%20and%20amber%20tone%20illustration%2C%20soft%20moonlight%2C%20editorial%20book%20stack%20composition&width=720&height=960&seq=col-novel-04&orientation=portrait",
  },
  {
    id: "c5",
    slug: "michiru-seiyu",
    title: "光流美知留·声优出演索引",
    category: "声优资料",
    categoryKey: "voice",
    series: "光流美知留出演表",
    author: "档案组 · 若叶",
    excerpt:
      "声优光流美知留的动画、广播剧、游戏与朗读作品出演索引，按年份与角色归类，声优爱好者可直接查表收藏。",
    tag: "声优专题",
    count: "46 项",
    updated: "2026-07-24",
    cover:
      "https://readdy.ai/api/search-image?query=voice%20actress%20profile%20archive%20portrait%20illustration%2C%20warm%20golden%20and%20cream%20tone%2C%20soft%20microphone%20and%20record%20theme%2C%20clean%20editorial%20composition%20with%20negative%20space&width=720&height=960&seq=col-voice-05&orientation=portrait",
  },
  {
    id: "c6",
    slug: "fengke-huaiji-doujin",
    title: "枫柯绘集·同人画作归档",
    category: "同人归档",
    categoryKey: "fanwork",
    series: "枫柯个人绘集",
    author: "档案组 · 白夜",
    excerpt:
      "同人画师枫柯历年画集、展贩本与线上插画归档目录，按年份与企划归类，收藏画集可按作者直接补全。",
    tag: "作者专题",
    count: "18 册",
    updated: "2026-07-18",
    cover:
      "https://readdy.ai/api/search-image?query=doujinshi%20artbook%20portrait%20cover%2C%20autumn%20maple%20theme%20illustration%2C%20warm%20terracotta%20and%20cream%20palette%2C%20soft%20paper%20texture%2C%20minimalist%20editorial%20layout&width=720&height=960&seq=col-doujin-06&orientation=portrait",
  },
  {
    id: "c7",
    slug: "chunfeng-duanpian",
    title: "春风短篇·动画精选合集",
    category: "动画合集",
    categoryKey: "anime",
    series: "春风短篇企划",
    author: "档案组 · 夏目",
    excerpt:
      "多部春风短篇企划动画的精选与特典归档，含制作阵容对照表，短篇爱好者可按企划补齐片单。",
    tag: "系列专题",
    count: "15 部",
    updated: "2026-07-10",
    cover:
      "https://readdy.ai/api/search-image?query=spring%20breeze%20short%20anime%20collection%20portrait%20cover%2C%20sakura%20and%20breeze%20theme%2C%20warm%20pink%20and%20cream%20watercolor%2C%20soft%20daylight%2C%20clean%20editorial%20layout&width=720&height=960&seq=col-anime-07&orientation=portrait",
  },
  {
    id: "c8",
    slug: "guanghe-manga-xingqi",
    title: "光河漫画·星际少年卷宗",
    category: "漫画合集",
    categoryKey: "manga",
    series: "光河作品集",
    author: "档案组 · 杏子",
    excerpt:
      "光河漫画《星际少年》全卷、外传与设定集整理，含连载年表与再版对照，方便按作品逐卷核对收藏。",
    tag: "作品专题",
    count: "22 卷",
    updated: "2026-07-03",
    cover:
      "https://readdy.ai/api/search-image?query=space%20boy%20manga%20volume%20portrait%20cover%2C%20stars%20and%20galaxy%20theme%2C%20warm%20indigo%20and%20amber%20palette%2C%20soft%20cosmic%20glow%2C%20editorial%20book%20composition&width=720&height=960&seq=col-manga-08&orientation=portrait",
  },
];

export const featuredIds = ["c1", "c3", "c4"];